import * as Yup from "yup";

import { LISTING_WIZARD_STEPS } from "./consts";

export const CHANNEL_PICKER_SCHEMA = Yup.object().shape({
  selectedChannelIds: Yup.array().min(1, "Odaberite barem jedan kanal"),
});

export const MARKETPLACE_SCHEMA = Yup.object().shape({
  baseTitle: Yup.string().required("Naslov je obavezan"),
  baseDescription: Yup.string().required("Opis je obavezan"),
});

// Slike imaju vlastiti korak (PictureStep) — validacija se okida između
// marketplace i price stepa.
export const PICTURE_SCHEMA = Yup.object().shape({
  selectedPictureUploadIds: Yup.array().min(1, "Odaberite barem jednu sliku"),
});

// Cijena ima vlastiti korak (PriceStep) — validacija se okida nakon
// picture stepa, prije prelaska na per-channel korake (ako su uključeni).
export const PRICE_SCHEMA = Yup.object().shape({
  basePrice: Yup.string()
    .required("Cijena je obavezna")
    .test("is-number", "Cijena mora biti broj", (v) => !v || !isNaN(Number(v))),
});

// Oglas mora imati kontakt — ili djelatnika iz postavki, ili kontakt iz imenika. Dva
// izvora se isključuju, pa je „oba prazna" jedini način da kontakta nema. Provjera visi
// na `contactId` da skrol iz `validateYupWithFeedback` pogodi baš to polje.
export const ADDITIONAL_INFO_SCHEMA = Yup.object().shape({
  marketplaceData: Yup.object().shape({
    contact: Yup.object().shape({
      contactId: Yup.string().test(
        "contact-required",
        "Odaberite kontakt za oglas",
        function (value) {
          const contact = this.parent as { contactUserIds?: string[] };

          return !!value || (contact?.contactUserIds?.length ?? 0) > 0;
        }
      ),
    }),
    // Lokacija mora postojati — ili preko poslovnice, ili ručno upisana. Općina se ne
    // traži: poslovnica je nema, pa bi je oglas s poslovnicom nikad ne bi mogao dati.
    // Provjera visi na `manualAddress` da skrol pogodi polje koje se u ručnom unosu vidi.
    location: Yup.object().shape({
      manualAddress: Yup.string().test(
        "location-required",
        "Odaberite poslovnicu ili unesite županiju, naselje i adresu",
        function () {
          const location = this.parent as {
            countyCode?: string;
            settlementCode?: string;
            manualAddress?: string;
          };
          // `from` su preci u shemi: [0] je location, [1] marketplaceData.
          const marketplaceData = (this as any).from?.[1]?.value as
            | { contact?: { locationOfficeIds?: string[] } }
            | undefined;

          const hasOffice =
            (marketplaceData?.contact?.locationOfficeIds?.length ?? 0) > 0;
          const hasManual =
            !!location?.countyCode?.trim() &&
            !!location?.settlementCode?.trim() &&
            !!location?.manualAddress?.trim();

          return hasOffice || hasManual;
        }
      ),
    }),
  }),
});

// Koraci koji nisu navedeni nemaju obaveznih polja — oglas smije proći bez slika
// i bez per-kanal prilagodbi.
const STEP_SCHEMAS: Record<number, Yup.AnyObjectSchema> = {
  [LISTING_WIZARD_STEPS.channelPicker]: CHANNEL_PICKER_SCHEMA,
  [LISTING_WIZARD_STEPS.marketplace]: MARKETPLACE_SCHEMA,
  [LISTING_WIZARD_STEPS.additionalInfo]: ADDITIONAL_INFO_SCHEMA,
  [LISTING_WIZARD_STEPS.price]: PRICE_SCHEMA,
};

export const getStepSchema = (step: number): Yup.AnyObjectSchema | null =>
  STEP_SCHEMAS[step] ?? null;
